if (!customElements.get('mix-and-match-slider')) {
  customElements.define(
    'mix-and-match-slider',
    class MixAndMatchSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {

        const section = this.closest('.mix-match-section');
        this.enableSliderDesktop = section?.dataset.enableSliderDesktop === 'true';
        this.enableSliderMobile = section?.dataset.enableSliderMobile === 'true';
        this.cartType = section?.dataset.cartType;
        
        if (this.cartType == 'cart') {
            this.items = parseInt(section?.dataset.items) || 2.7;
        }else{
            this.items = parseInt(section?.dataset.itemsDrawer) || 1.2;
        }

        this.itemsMobile = parseInt(section?.dataset.itemsMobile) || 1.2;

        if (!this.enableSliderDesktop && !this.enableSliderMobile) return;

        this.selectors = {
          swiperContainer: '.swiper',
          swiperWrapper: '.swiper-wrapper',
        };

        this.classes = {
          grid: 'f-grid', 
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.swiperContainer = this.querySelector(this.selectors.swiperContainer);
        this.swiperWrapper = this.querySelector(this.selectors.swiperWrapper);
        this.sliderInstance = false;

        if (typeof window.FoxTheme !== 'undefined' && window.FoxTheme.config) {
          const mql = window.matchMedia(window.FoxTheme.config.mediaQueryMobile || '(max-width: 767px)');
          mql.onchange = this.init.bind(this);
        }
        
        this.init();
      }

      init() {
        const isMobile = typeof window.FoxTheme !== 'undefined' && window.FoxTheme.config 
          ? window.FoxTheme.config.mqlMobile 
          : window.matchMedia('(max-width: 767px)').matches;

        if (isMobile) {
          if (this.enableSliderMobile) {
            this.initSlider();
          } else {
            this.destroySlider();
          }
        } else {
          if (this.enableSliderDesktop) {
            this.initSlider();
          } else {
            this.destroySlider();
          }
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const spaceBetween = 12;
        const spaceBetweenMobile = 12;

        this.sliderOptions = {
          slidesPerView: this.itemsMobile,
          spaceBetween: spaceBetweenMobile,
          breakpoints: {
            768: {
              slidesPerView: this.items,
              spaceBetween: spaceBetween,
            },
          },
          navigation: {
            nextEl: document.querySelector('.swiper-button-next--mix-match'),
            prevEl: document.querySelector('.swiper-button-prev--mix-match'),
          },
          pagination: {
            el: document.querySelector('.swiper-pagination--mix-match'),
            clickable: true,
            type: 'fraction',
          },
          loop: false,
          threshold: 2,
          grabCursor: true,
          allowTouchMove: true,
        };
        
        if (this.swiperContainer) {
          this.swiperContainer.classList.add(this.classes.swiper);
        }
        if (this.swiperWrapper) {
          this.swiperWrapper.classList.add(this.classes.swiperWrapper);
          this.swiperWrapper.classList.remove(this.classes.grid);
        }

        if (typeof window.FoxTheme !== 'undefined' && window.FoxTheme.Carousel) {
          this.sliderInstance = new window.FoxTheme.Carousel(this.swiperContainer, this.sliderOptions);
          this.sliderInstance.init();
        } else if (typeof window.Swiper !== 'undefined') {
          this.sliderInstance = new window.Swiper(this.swiperContainer, this.sliderOptions);
        } else {
          console.warn('Neither FoxTheme.Carousel nor Swiper is available');
          return;
        }

        this.handleAccessibility();
      }

      handleAccessibility() {
        if (typeof window.FoxTheme !== 'undefined' && window.FoxTheme.a11y) {
          const focusableElements = window.FoxTheme.a11y.getFocusableElements(this);

          focusableElements.forEach((element) => {
            element.addEventListener('focusin', (event) => {
              if (event.relatedTarget !== null) {
                if (element.closest('.swiper-slide')) {
                  const slide = element.closest('.swiper-slide');
                  const slideIndex = Array.from(this.sliderInstance.slider.slides).indexOf(slide);
                  this.sliderInstance.slider.slideTo(slideIndex);
                }
              } else {
                element.blur();
              }
            });
          });
        } else {
          const focusableElements = this.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
          
          focusableElements.forEach((element) => {
            element.addEventListener('focusin', () => {
              const slide = element.closest('.swiper-slide');
              if (slide && this.sliderInstance) {
                const slideIndex = Array.from(slide.parentElement.children).indexOf(slide);
                if (this.sliderInstance.slider && this.sliderInstance.slider.slideTo) {
                  this.sliderInstance.slider.slideTo(slideIndex);
                } else if (this.sliderInstance.slideTo) {
                  this.sliderInstance.slideTo(slideIndex);
                }
              }
            });
          });
        }
      }

      destroySlider() {
        if (this.swiperContainer) {
          this.swiperContainer.classList.remove(this.classes.swiper);
        }
        if (this.swiperWrapper) {
          this.swiperWrapper.classList.remove(this.classes.swiperWrapper);
          this.swiperWrapper.classList.add(this.classes.grid);
        }
        
        if (typeof this.sliderInstance !== 'object') return;
        
        if (this.sliderInstance.slider && this.sliderInstance.slider.destroy) {
          this.sliderInstance.slider.destroy();
        } else if (this.sliderInstance.destroy) {
          this.sliderInstance.destroy();
        }
        
        this.sliderInstance = false;
      }
    }
  );
}